import actions from "./actions";

const {
    KNOWLEDGE_BASE_BEGIN,
    KNOWLEDGE_BASE_SUCCESS,
    KNOWLEDGE_BASE_ERR,
    KNOWLEDGE_BASE_ADD_BEGIN,
    KNOWLEDGE_BASE_ADD_SUCCESS,
    KNOWLEDGE_BASE_ADD_ERR,
    KNOWLEDGE_BASE_UPDATE_BEGIN,
    KNOWLEDGE_BASE_UPDATE_SUCCESS,
    KNOWLEDGE_BASE_UPDATE_ERR,
    KNOWLEDGE_BASE_DELETE_BEGIN,
    KNOWLEDGE_BASE_DELETE_SUCCESS,
    KNOWLEDGE_BASE_DELETE_ERR,
    KNOWLEDGE_BASE_GROUP_ADD_BEGIN,
    KNOWLEDGE_BASE_GROUP_ADD_SUCCESS,
    KNOWLEDGE_BASE_GROUP_ADD_ERR,
    KNOWLEDGE_BASE_GROUP_UPDATE_BEGIN,
    KNOWLEDGE_BASE_GROUP_UPDATE_SUCCESS,
    KNOWLEDGE_BASE_GROUP_UPDATE_ERR,
    KNOWLEDGE_BASE_GROUP_DELETE_BEGIN,
    KNOWLEDGE_BASE_GROUP_DELETE_SUCCESS,
    KNOWLEDGE_BASE_GROUP_DELETE_ERR,
    KNOWLEDGE_BASE_LEARN_BEGIN,
    KNOWLEDGE_BASE_LEARN_SUCCESS,
    KNOWLEDGE_BASE_LEARN_ERR,
    KNOWLEDGE_BASE_BULK_ADD_BEGIN,
    KNOWLEDGE_BASE_BULK_ADD_SUCCESS,
    KNOWLEDGE_BASE_BULK_ADD_ERR,
    KNOWLEDGE_BASE_PHRASES_BEGIN,
    KNOWLEDGE_BASE_PHRASES_SUCCESS,
    KNOWLEDGE_BASE_PHRASES_ERR,
    KNOWLEDGE_BASE_TEST_LOOKUP_BEGIN,
    KNOWLEDGE_BASE_TEST_LOOKUP_SUCCESS,
    KNOWLEDGE_BASE_TEST_LOOKUP_ERR,
    TEST_AI_PREVIEW_BEGIN,
    TEST_AI_PREVIEW_SUCCESS,
    TEST_AI_PREVIEW_ERR,
    TEST_AI_PREVIEW_CLEAR_ERROR,
} = actions;

const initState = {
    list: null,
    loading: false,
    adding: false,
    updating: false,
    deleting: false,
    groupAdding: false,
    groupUpdating: false,
    groupDeleting: false,
    error: null,
    learnLoading: false,
    learnSuggestions: [],
    learnError: null,
    bulkAdding: false,
    bulkAddError: null,
    phrasesGenerating: false,
    phrasesError: null,
    testLookupLoading: false,
    testBookingInfo: null,
    testLookupError: null,
    previewGuestLoading: false,
    previewListingLoading: false,
    previewHostLoading: false,
    previewListingData: null,
    previewHostData: null,
    previewListingError: null,
    previewHostError: null,
    previewOnboardingLoading: false,
};

const KnowledgeBaseReducer = (state = initState, action) => {
    const { type, data, err } = action;
    switch (type) {
        case KNOWLEDGE_BASE_BEGIN:
            return { ...state, loading: true, error: null };
        case KNOWLEDGE_BASE_SUCCESS:
            return { ...state, list: data, loading: false };
        case KNOWLEDGE_BASE_ERR:
            return { ...state, error: err, loading: false };

        case KNOWLEDGE_BASE_ADD_BEGIN:
            return { ...state, adding: true, error: null };
        case KNOWLEDGE_BASE_ADD_SUCCESS:
            return { ...state, adding: false };
        case KNOWLEDGE_BASE_ADD_ERR:
            return { ...state, adding: false, error: err };

        case KNOWLEDGE_BASE_UPDATE_BEGIN:
            return { ...state, updating: true, error: null };
        case KNOWLEDGE_BASE_UPDATE_SUCCESS:
            return { ...state, updating: false };
        case KNOWLEDGE_BASE_UPDATE_ERR:
            return { ...state, updating: false, error: err };

        case KNOWLEDGE_BASE_DELETE_BEGIN:
            return { ...state, deleting: true, error: null };
        case KNOWLEDGE_BASE_DELETE_SUCCESS:
            return { ...state, deleting: false };
        case KNOWLEDGE_BASE_DELETE_ERR:
            return { ...state, deleting: false, error: err };

        case KNOWLEDGE_BASE_GROUP_ADD_BEGIN:
            return { ...state, groupAdding: true, error: null };
        case KNOWLEDGE_BASE_GROUP_ADD_SUCCESS:
            return { ...state, groupAdding: false };
        case KNOWLEDGE_BASE_GROUP_ADD_ERR:
            return { ...state, groupAdding: false, error: err };

        case KNOWLEDGE_BASE_GROUP_UPDATE_BEGIN:
            return { ...state, groupUpdating: true, error: null };
        case KNOWLEDGE_BASE_GROUP_UPDATE_SUCCESS:
            return { ...state, groupUpdating: false };
        case KNOWLEDGE_BASE_GROUP_UPDATE_ERR:
            return { ...state, groupUpdating: false, error: err };

        case KNOWLEDGE_BASE_GROUP_DELETE_BEGIN:
            return { ...state, groupDeleting: true, error: null };
        case KNOWLEDGE_BASE_GROUP_DELETE_SUCCESS:
            return { ...state, groupDeleting: false };
        case KNOWLEDGE_BASE_GROUP_DELETE_ERR:
            return { ...state, groupDeleting: false, error: err };

        case KNOWLEDGE_BASE_LEARN_BEGIN:
            return { ...state, learnLoading: true, learnSuggestions: [], learnError: null };
        case KNOWLEDGE_BASE_LEARN_SUCCESS:
            return { ...state, learnLoading: false, learnSuggestions: Array.isArray(data) ? data : [] };
        case KNOWLEDGE_BASE_LEARN_ERR:
            return { ...state, learnLoading: false, learnError: err };

        case KNOWLEDGE_BASE_BULK_ADD_BEGIN:
            return { ...state, bulkAdding: true, bulkAddError: null };
        case KNOWLEDGE_BASE_BULK_ADD_SUCCESS:
            return { ...state, bulkAdding: false };
        case KNOWLEDGE_BASE_BULK_ADD_ERR:
            return { ...state, bulkAdding: false, bulkAddError: err };

        // The phrases themselves go straight back to the editor that asked for them,
        // so only the flags are kept here.
        case KNOWLEDGE_BASE_PHRASES_BEGIN:
            return { ...state, phrasesGenerating: true, phrasesError: null };
        case KNOWLEDGE_BASE_PHRASES_SUCCESS:
            return { ...state, phrasesGenerating: false };
        case KNOWLEDGE_BASE_PHRASES_ERR:
            return { ...state, phrasesGenerating: false, phrasesError: err };

        case KNOWLEDGE_BASE_TEST_LOOKUP_BEGIN:
            return { ...state, testLookupLoading: true, testBookingInfo: null, testLookupError: null };
        case KNOWLEDGE_BASE_TEST_LOOKUP_SUCCESS:
            return { ...state, testLookupLoading: false, testBookingInfo: data };
        case KNOWLEDGE_BASE_TEST_LOOKUP_ERR:
            return { ...state, testLookupLoading: false, testLookupError: err };

        case TEST_AI_PREVIEW_BEGIN:
            return {
                ...state,
                previewGuestLoading:      action.previewType === 'guest'      ? true  : state.previewGuestLoading,
                previewListingLoading:    action.previewType === 'listing'    ? true  : state.previewListingLoading,
                previewHostLoading:       action.previewType === 'host'       ? true  : state.previewHostLoading,
                previewOnboardingLoading: action.previewType === 'onboarding' ? true  : state.previewOnboardingLoading,
                previewListingData:       action.previewType === 'listing'    ? null  : state.previewListingData,
                previewHostData:          action.previewType === 'host'       ? null  : state.previewHostData,
                previewListingError:      action.previewType === 'listing'    ? null  : state.previewListingError,
                previewHostError:         action.previewType === 'host'       ? null  : state.previewHostError,
            };
        case TEST_AI_PREVIEW_SUCCESS:
            return {
                ...state,
                previewGuestLoading:      action.previewType === 'guest'      ? false : state.previewGuestLoading,
                previewListingLoading:    action.previewType === 'listing'    ? false : state.previewListingLoading,
                previewHostLoading:       action.previewType === 'host'       ? false : state.previewHostLoading,
                previewOnboardingLoading: action.previewType === 'onboarding' ? false : state.previewOnboardingLoading,
                previewListingData:       action.previewType === 'listing'    ? action.data : state.previewListingData,
                previewHostData:          action.previewType === 'host'       ? action.data : state.previewHostData,
            };
        case TEST_AI_PREVIEW_ERR:
            return {
                ...state,
                previewGuestLoading:      action.previewType === 'guest'      ? false : state.previewGuestLoading,
                previewListingLoading:    action.previewType === 'listing'    ? false : state.previewListingLoading,
                previewHostLoading:       action.previewType === 'host'       ? false : state.previewHostLoading,
                previewOnboardingLoading: action.previewType === 'onboarding' ? false : state.previewOnboardingLoading,
                previewListingError:      action.previewType === 'listing'    ? action.err : state.previewListingError,
                previewHostError:         action.previewType === 'host'       ? action.err : state.previewHostError,
            };

        case TEST_AI_PREVIEW_CLEAR_ERROR:
            return {
                ...state,
                previewListingError: action.previewType === 'listing' ? null : state.previewListingError,
                previewHostError:    action.previewType === 'host'    ? null : state.previewHostError,
            };

        default:
            return state;
    }
};

export default KnowledgeBaseReducer;
